// extracted by mini-css-extract-plugin
export default {"gradient-bg5":"form__gradient-bg5__PY45k","terms":"form__terms__A1P0S","addAnotherContainer":"form__addAnotherContainer__QhBCH","addAnother":"form__addAnother__M3RFM"};